import { render, staticRenderFns } from "./cascaderType.vue?vue&type=template&id=07954ff4"
import script from "./cascaderType.vue?vue&type=script&lang=js"
export * from "./cascaderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports